module.exports = __webpack_public_path__ + "img/u20.a478be9f.png";